import { CtCatalogueStockItem } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'Stock item ID',
      validator: () => true,
      type: 'link',
      contentType: 'stock_item',
      required: true
    },
    catalogue: {
      field: 'catalogue',
      label: 'Catalogue',
      validator: () => true,
      type: 'link',
      contentType: 'supplier_catalogue',
      required: true
    },
    title: {
      field: 'title',
      label: 'Title',
      validator: () => true,
      type: 'string',
      required: false
    },
    description: {
      field: 'description',
      label: 'Description',
      validator: () => true,
      type: 'string',
      required: false
    },
    tax_tier: {
      field: 'tax_tier',
      label: 'Tax Tier',
      validator: () => true,
      type: 'string',
      required: false
    },
    deliverable_from: {
      field: 'deliverable_from',
      label: 'Deliverable From',
      validator: () => true,
      type: 'string',
      required: false
    },
    deliverable_to: {
      field: 'deliverable_to',
      label: 'Deliverable To',
      validator: () => true,
      type: 'string',
      required: false
    },
    supply_chain_tracking_id: {
      field: 'supply_chain_tracking_id',
      label: 'Supply-chain tracking ID ',
      validator: () => true,
      type: 'string',
      default: false,
      required: false
    },
    active: {
      field: 'active',
      label: 'Available',
      validator: () => true,
      type: 'boolean',
      default: true,
      required: false
    },
    // images: {
    //   field: 'images',
    //   label: 'Images',
    //   validator: () => true,
    //   type: 'link-list',
    //   contentType: '__asset',
    //   required: false
    // },
    meta: {
      field: 'json',
      label: 'Metadata',
      validator: () => true,
      type: 'json',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtCatalogueStockItem>(
  ContentType.CatalogueStockItem, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
